<template>
  <div>
    <div class="head">
      <div class="top-nav">
        <div class="content">
          <div class="riqi">
            <span id="localtime" v-html="today"></span>
          </div>
          <div class="header-r">
            <div class="search" style="margin-top:-15px;">
              <form
                target="_blank"
                name="searchForm"
                id="searchForm"
              >
                <input
                  type="text"
                  name="q"
                  value
                  maxlength="50"
                  autocomplete="off"
                  class="searchCon"
                  placeholder="搜索"
                />
                <input type="hidden" name="token" id="token" value />
                
              </form>
            </div>
          </div>
          <div class="header_login" style="margin-top:10px;">
            <ul>
              <li class="login" v-if="this.$root.userName==undefined">
                <router-link to="/login" class="tc">登录</router-link>
              </li>
              <li class="register" v-if="this.$root.userName==undefined">
                <router-link to="/register" class="tc">注册</router-link>
              </li>
              <li class="login on" v-if="this.$root.userName">
                <a style="display: inline-block;margin-right: 5px">{{userName}}</a>
              </li>
              <li class="user-child" v-if="this.$root.userName">
                <a @click="touser()">会员中心</a>
              </li>
              <li class="user-child" v-if="this.$root.userName">
                <a @click="logout" style="display: inline-block;">退出账号</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="content">
        <img src="../assets/login_zjz.png" alt class="logo" />
      </div>

      <input value style="display: none" id="userSessionId" />
    </div>
    <div class="member-con">
      <div class="m-pos" style="margin-left:-1100px;">
        <a @click="toIndex">首页</a> >
        <span>会员中心</span>
      </div>
      <div class="member clearfix">
        <div class="memberLeft clearfix">
          <div class="member-nav">
            <ul>
              <li>
                <a  class="on" @click="getUserInfo">个人资料</a>
              </li>
              <!--<li><a href="/member/contribute_list.jspx">投稿管理</a></li>-->
              <!--<li><a href="/member/doc_list.jspx?modelId=9">文档管理</a></li>-->
              <!--<li><a href="/member/resume.jspx">应聘管理</a></li>-->
              <!--<li><a href="/member/mycomments.jspx">我的评论</a></li>-->
              <!--<li><a href="/member/myguestbook.jspx">我的留言</a></li>-->
              <!--<li><a href="/member/collection_list.jspx">我的收藏</a></li>-->
              <!--<li><a href="/member/message_mng.jspx">站内信息</a></li>-->
              <!--<li><a href="/member/account.jspx">服务中心</a></li>-->
            </ul>
          </div>
          <div class="member-main" style="margin-left:-80px;">
            <div class="member-child">
              <a class="on" @click="getUserInfo">用户信息</a>|
              <a @click="editUserInfo">修改个人资料</a>|
              <a>个人中心</a>|
              <a>更换头像</a>|
              <a @click="editPass">修改密码</a>
            </div>
            <div class="member-text" v-if="userType==1">
              <table cellpadding="0" cellspacing="0">
                <tbody>
                  <tr>
                    <td class="s-p">用户昵称：</td>
                    <td width="40%" style="text-align:left">{{form.userName}}</td>
                    <td class="s-p">会员组别：</td>
                    <td width="40%" class="hyzb" style="text-align:left">普通会员</td>
                  </tr>
                  <tr>
                    <td class="s-p">性别：</td>
                    <td style="text-align:left">{{showSex(form.userSex)}}</td>
                    <td class="s-p">出生日期：</td>
                    <td style="text-align:left">{{form.userBirthday}}</td>
                  </tr>
                  <tr>
                    <td class="s-p">真实姓名：</td>
                    <td style="text-align:left">{{form.userActualName}}</td>
                    <td class="s-p">邮箱：</td>
                    <td style="text-align:left">{{form.userEmail}}</td>
                  </tr>
                  <tr>
                    <td class="s-p">手机：</td>
                    <td style="text-align:left">{{form.userPhone}}</td>
                    <td class="s-p">固定电话：</td>
                    <td style="text-align:left">{{form.userTelephone}}</td>
                  </tr>
                  <tr>
                    <td class="s-p">QQ：</td>
                    <td style="text-align:left">{{form.userQq}}</td>
                    <td class="s-p">MSN：</td>
                    <td style="text-align:left">{{form.userMsg}}</td>
                  </tr>
                  <tr>
                    <td class="s-p">来自：</td>
                    <td style="text-align:left">{{form.userBirthplace}}</td>
                  </tr>
                  <tr>
                    <td class="s-p">自我介绍：</td>
                    <td style="text-align:left">{{form.remarks}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="member-text" v-if="userType==2">
              <el-form ref="form" :model="form" label-width="80px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="性别" style="margin-bottom:0px">
                      <el-radio-group v-model="form.userSex">
                        <el-radio :label="1">男</el-radio>
                        <el-radio :label="0">女</el-radio>
                        <el-radio :label="2">保密</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="出生日期" prop="userBirthday" style="margin-bottom:0px">
                      <el-date-picker
                        style="width:260px"
                        type="datetime"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期"
                        v-model="form.userBirthday"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="真实姓名" prop="userActualName" style="margin-bottom:0px">
                      <el-input placeholder="请输入真实姓名" maxlength="70" v-model="form.userActualName"/>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="手机" prop="userPhone" style="margin-bottom:0px">
                      <el-input placeholder="手机" maxlength="50" v-model="form.userPhone"/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="固定电话" prop="userTelephone" style="margin-bottom:0px">
                      <el-input placeholder="固定电话" maxlength="20" v-model="form.userTelephone"/>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="qq" prop="userQq" style="margin-bottom:0px">
                      <el-input placeholder="qq" v-model="form.userQq"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item label="MSN" prop="userMsg" style="margin-bottom:0px">
                      <el-input placeholder="MSN" v-model="form.userMsg"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="来自" prop="userBirthplace" style="margin-bottom:0px">
                      <el-input placeholder="来自" maxlength="150" v-model="form.userBirthplace"/>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-form-item prop="remarks" label="自我介绍" style="margin-bottom:0px">
                    <el-input type="textarea" placeholder="自我介绍" maxlength="400" v-model="form.remarks" :rows="5"></el-input>
                  </el-form-item>
                </el-row>
              </el-form>
              <div style="margin-top:30px;margin-left:80px;">
                <el-row :gutter="10" class="mb8">
                  <el-col :span="1.5">
                 <el-button type="danger" @click="submitUser" style="height: 33px;width:80px;">提交</el-button>
                 </el-col>
                  <el-col :span="1.5">
                  <el-button type="danger" @click="reset" plain style="height: 33px; width:80px;">重置</el-button>
                  </el-col>
                  </el-row>
              </div>
            </div>
            <div class="member-text c-p" v-if="userType==3"  style="margin-left:90px;margin-top:30px">
               <el-form ref="passWord" :rules="rules" :model="passWord" label-width="80px">
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="原密码" prop="userPassword" style="margin-bottom:20px">
                      <el-input placeholder="请输入原密码" show-password v-model="passWord.userPassword" maxlength="70" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="新密码" prop="newPassword" style="margin-bottom:20px">
                      <el-input placeholder="请输入新密码" show-password v-model="passWord.newPassword" maxlength="50" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="确认密码" prop="newUserPassWord2" style="margin-bottom:20px">
                      <el-input placeholder="确认密码" show-password v-model="passWord.newUserPassWord2"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="12">
                    <el-form-item label="邮箱" prop="userEmail" style="margin-bottom:20px">
                      <el-input  maxlength="30" v-model="passWord.userEmail" />
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <div style="margin-top:0px;margin-left:80px;">
                <el-row :gutter="10" class="mb8">
                  <el-col :span="1.5">
                 <el-button type="danger" @click="editPassWord" style="height: 33px;width:210px;">提交</el-button>
                 </el-col>
                  </el-row>
              </div>
            </div>
          </div>
        </div>
        <div class="memberRight">
          <div class="memberImg">
            <img id="img" src="../styles/images/userImg-large.png" />
          </div>
          <div class="memberName">
            您好，
            <span>{{userName}}</span>
          </div>
          <div class="memberOut">
            <a @click="logout" >退出</a>
          </div>
        </div>
        <div class="m-sj"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getUsers,updateUser,updatePassword } from "@/api/content/column";
export default {
  name: "Header",
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6||value.length > 20) {
        callback(new Error('密码长度必须在5到20个字符之间'))
      } else {
        callback()
      }
    }
    const validateConfirmPassword = (rule, value, callback) => {
      if (value != this.passWord.newPassword) {
        callback(new Error('密码不一致,请重新输入'))
      } else {
        callback()
      }
    }
    return {
      rules: {
        userPassword: [
          { required: true, trigger: 'blur', message: '密码不能为空'},
          { min: 6, max: 20, message: '密码长度必须在5到20个字符之间', trigger: 'blur' },
        ],
        newPassword: [
          { required: true, trigger: 'blur', message: '密码不能为空'},
          { min: 6, max: 20, message: '密码长度必须在5到20个字符之间', trigger: 'blur' },
        ],
        newUserPassWord2: [
          { required: true, trigger: 'blur', validator: validateConfirmPassword }
        ]

      },
      timer: null,
      today: null,
      col: null,
      userName: undefined,
      userType: 1,
      form: {},
      userId:null,
      passWord:{
        id:null,
        userPassword:null,
        newPassword:null,
        newUserPassWord2:null,
        userEmail:null
      }
    };
  },
  watch: {
    $route(val, from) {
      // 拿到目标参数 val.query.id 去请求接口
      this.userName = localStorage.getItem("userName");
    }
  },
  created() {
    this.init();
    //创建生命周期时候启动定时器
    this.startTimer();
    this.userName = localStorage.getItem("userName");
  },
  methods: {
    showSex(index){
      if(index==0) return '女';
      if(index==1) return '男';
      if(index==2) return '保密';
    },
    reset() {
      this.form = {
        id: null,
        userName: null,
        userEmail: null,
        userPassword: null,
        userActualName: null,
        vipId: null,
        userProfit: null,
        userSex: null,
        userBirthday: null,
        userBirthplace: null,
        userQq: null,
        userMsg: null,
        userTelephone: null,
        userPhone: null,
        status: 0,
        remarks: null,
        gmtCreate: null,
        gmtUpdate: null,
        userIp: null,
        userLastTime: null,
        userLoginCount: null,
        token:null,
      };
      this.resetForm("form");
    },
    init(){
      const userName = localStorage.getItem("userName");
      const id = localStorage.getItem("userId");
      console.log(id,1111+userName);
      this.userType = 1;
      getUsers(id).then(response => {
        this.form = response.data;
      });
    },
    submitUser(){
      updateUser(this.form).then(response => {
          this.$alert("<font color='red'> 修改成功</font>", "系统提示", {
            dangerouslyUseHTMLString: true,
            type: "success"
          })
            .then(() => {
              this.userType = 1;
            })
            .catch(() => {});
      });
    },
    editPassWord(){
      this.$refs['passWord'].validate(valid => {
        if (valid) {
          this.passWord.id=localStorage.getItem("userId");
          updatePassword(this.passWord).then(response => {
            this.$alert("<font color='red'> 密码修改成功</font>", "系统提示", {
            dangerouslyUseHTMLString: true,
            type: "success"
          })
            .then(() => {
              this.userType = 1;
            })
            .catch(() => {});
          });
        }

      });
    },
    getUserInfo() {
      const userName = localStorage.getItem("userName");
      const id = localStorage.getItem("userId");
      console.log(id,1111+userName);
      this.userType = 1;
      getUsers(id).then(response => {
        this.form = response.data;
      });
    },
    editUserInfo() {
      this.userType = 2;
    },
    editPass() {
      this.userType = 3;
      this.passWord.userPassword=null,
      this.passWord.newPassword=null,
      this.passWord.newUserPassWord2=null,
      this.passWord.userEmail=this.form.userEmail;
    },
    touser() {
      this.$router.push({ path: "/user", query: { id: 1 } });
    },
    logout() {
      localStorage.removeItem("userName");
      localStorage.removeItem("id");
      localStorage.removeItem("token");
      this.$root.userName = undefined;
      this.$router.push('/')
    },
    //去首页
    toIndex() {
      this.$root.num = 1;
      this.$router.push("/");
    },
    toAitrcle(index) {
      this.$root.num = index;
      this.$router.push({ path: "/Aitrcle", query: { id: index } });
    },
    toword(index) {
      this.$root.num = index;
      this.$router.push({ path: "/leaveWord", query: { id: index } });
    },
    toXs(index) {
      this.$root.num = index;
    },
    toJgjj(index) {
      console.log(index);
      this.$root.num = index;
      this.$router.push({ path: "/jgjj", query: { id: 32 } });
    },
    //启动定时器
    startTimer() {
      this.timer = setInterval(() => {
        this.getTime();
      }, 2000);
    },
    //获取当前时间
    getTime() {
      let date = new Date();
      let str, colorhead, colorfoot;
      let yy = date.getYear();
      if (yy < 1900) yy = yy + 1900;
      let MM = date.getMonth() + 1;
      if (MM < 10) MM = "0" + MM;
      let dd = date.getDate();
      if (dd < 10) dd = "0" + dd;
      let hh = date.getHours();
      if (hh < 10) hh = "0" + hh;

      let ww = date.getDay();
      if (ww == 0) colorhead = '<font color="#FF0000">';
      if (ww > 0 && ww < 6) colorhead = '<font color="#373737">';
      if (ww == 6) colorhead = '<font color="#008000">';
      if (ww == 0) ww = "星期日";
      if (ww == 1) ww = "星期一";
      if (ww == 2) ww = "星期二";
      if (ww == 3) ww = "星期三";
      if (ww == 4) ww = "星期四";
      if (ww == 5) ww = "星期五";
      if (ww == 6) ww = "星期六";
      colorfoot = "</font>";
      str =
        colorhead +
        "今天是:   " +
        yy +
        "年" +
        MM +
        "月" +
        dd +
        "日" +
        "    " +
        ww +
        colorfoot;
      console.log(this.str);
      this.today = str;
    }
  }
};
</script>
<style scoped>
@import "../styles/home.css";
@import "../styles/pages.css";
@import "../styles/style.css";
@import "../styles/index1.css";
@import "../styles/font.css";
.cols {
  color: white;
  background: #24a1ff;
}

#imgConac {
  width: unset;
  height: unset;
}
.searchMenu1{margin-top:-29px;margin-right:5px;float:right; width:34px; height:30px; background:url(../styles/images/icon-search.png) no-repeat 0 3px; outline:none; cursor:pointer;}
</style>


// WEBPACK FOOTER //
// src/components/user.vue